// extracted by mini-css-extract-plugin
export default {"container_main":"app_container_main__Ml+qj"};